const DEFAULT_MP_APP_ID = 'wx2a1e0d328ba08e92'
const DYCX_MP_APP_ID = 'wx88e619857c7d7564'
const DYCX_PARK_ID = '25'

const getOfficialAccountAppId = parkId =>
  String(parkId) === DYCX_PARK_ID ? DYCX_MP_APP_ID : DEFAULT_MP_APP_ID

module.exports = {
  DEFAULT_MP_APP_ID,
  DYCX_MP_APP_ID,
  getOfficialAccountAppId
}
